import { IImageDto } from "./IImageDto";

export class ImageDto implements IImageDto {
    id?: string | undefined;
    date: Date = new Date();
    url: string = "";
    isPortrait: boolean = false;
    tags: Array<string> = [];

    constructor(data?: IImageDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }
}
